import { render } from "./grow-kyc-audit-result.vue?vue&type=template&id=562c8826&scoped=true"
import script from "./grow-kyc-audit-result.vue?vue&type=script&lang=js"
export * from "./grow-kyc-audit-result.vue?vue&type=script&lang=js"

import "./grow-kyc-audit-result.vue?vue&type=style&index=0&id=562c8826&scoped=true&lang=css"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562c8826"]])

export default __exports__